import { Flex } from "@nef/core"

import CopyClipboardIcon from "../../CommonComponents/CopyClipboardIcon"
import { sortColumn } from "../../utils/common"
import { dateFormatForDisplay } from "../../utils/datetimehandler"

const symbolGeneratorColumns = (onSymbolClick: Function) => {
  return [
    {
      Header: "Symbol",
      width: "150",
      accessor: (data: any) => {
        return data.symbol ? (
          <>
          <Flex>
            <CopyClipboardIcon onClick={(event: React.MouseEvent<HTMLButtonElement>) => onSymbolClick(event, data.symbol)} />
            <span style={{marginLeft : '1rem'}}>{data.symbol}</span>
          </Flex>
          </>
        ) : (
          "-"
        )
      },
      id: "symbol"
    },
    {
      Header: "Last Used Date",
      width: "150",
      sortType: (rowA: any, rowB: any) => sortColumn(rowA, rowB, "lastUsedDate"),
      accessor: (data: any) => {
        return dateFormatForDisplay(data.lastUsedDate)
      },
      id: "lastUsedDate"
    },
    {
      Header: "Status",
      width: "150",
      accessor: (data: any) => {
        return data.status || "-"
      },
      id: "status"
    }
  ]
}

export const symbolGeneratorRulesColumns = [
  {
    Header: "Asset Class",
    width: "450",
    maxWidth : '450',
    accessor: 'assetClass',
  },
  {
    Header: "Symbol Length",
    accessor: 'symbolLength'
  },
  {
    Header: "Starting Letters",
    width : '170',
    accessor: 'startingLetters'
  },
  {
    Header: "Ending Letters",
    accessor: 'endingLetters'
  },
]


export const symbolGeneratorRules = [
  {
    assetClass : 'Mutual Fund – Open End or Demand Deposit Account',
    symbolLength : '5',
    startingLetters : 'Any letter except X',
    endingLetters : 'X'
  },
  {
    assetClass : 'Mutual Fund – Interval Fund or Tender Offer Fund',
    symbolLength : '5',
    startingLetters : 'Any letter',
    endingLetters : 'X'
  },
  {
    assetClass : 'Mutual Fund – Closed End or Exchange Traded Fund',
    symbolLength : '5',
    startingLetters : 'X',
    endingLetters : 'X'
  },
  {
    assetClass : 'Money Market Fund',
    symbolLength : '5',
    startingLetters : 'Any letter',
    endingLetters : 'XX'
  },
  {
    assetClass : 'Unit Investment Trust, Collective Investment Trust, Managed Account, Separate Account',
    symbolLength : '6',
    startingLetters : 'Any letter except P, Q, X or Z',
    endingLetters : 'X'
  },
  {
    assetClass : 'Annuity',
    symbolLength : '6',
    startingLetters : 'Q',
    endingLetters : 'X'
  },
  {
    assetClass : 'Structured Product',
    symbolLength : '7',
    startingLetters : 'Any letter',
    endingLetters : 'XX'
  },
  {
    assetClass : 'Alternative Investment Product, Hedge Fund',
    symbolLength : '6',
    startingLetters : 'Z',
    endingLetters : 'X'
  },
  {
    assetClass : 'Private Stock',
    symbolLength : '7',
    startingLetters : 'Any letters',
    endingLetters : 'X'
  }
]

export default symbolGeneratorColumns
